import { render, staticRenderFns } from "./menuProject.vue?vue&type=template&id=0f6915e9&scoped=true&"
import script from "./menuProject.vue?vue&type=script&lang=js&"
export * from "./menuProject.vue?vue&type=script&lang=js&"
import style0 from "./menuProject.vue?vue&type=style&index=0&id=0f6915e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6915e9",
  null
  
)

export default component.exports